// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1u2Lc","fileBtn":"File_fileBtn__v9mhv","closeBtn":"File_closeBtn__14xtQ","fileSelected":"File_fileSelected__3gguX","disabled":"File_disabled__1HYIW"};